import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { otherAttendanceActions as actions, notificationActions } from '../actions';
import { otherAttendanceService } from '../services';

/* Self Attendance Sagas */
function* handleSelfAttendanceRequest() {
  const action = yield take(actions.selfAttendanceRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(otherAttendanceService.selfAttendance, dataParams);
    if (res.isError) {
      yield put(actions.selfAttendanceError(res));
    } else {
      yield put(actions.selfAttendanceSuccess(res));
    }
  } catch (error) {
    yield put(actions.selfAttendanceError());
  }
}

/* My Team Attendance Sagas*/
function* handleMyTeamAttendanceRequest() {
  const action = yield take(actions.myTeamAttendanceRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(otherAttendanceService.myTeamAttendance, dataParams);

    if (res.isError) {
      yield put(actions.myTeamAttendanceError(res));

    } else {
      yield put(actions.myTeamAttendanceSuccess(res));
    }

  } catch (error) {
    yield put(actions.myTeamAttendanceError());
  }
}

/* All Team Attendance Sagas*/
function* handleAllTeamAttendanceRequest() {
  const action = yield take(actions.allTeamAttendanceRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(otherAttendanceService.allTeamAttendance, dataParams);

    if (res.isError) {
      yield put(actions.allTeamAttendanceError(res));

    } else {
      yield put(actions.allTeamAttendanceSuccess(res));
    }

  } catch (error) {
    yield put(actions.allTeamAttendanceError());
  }
}

/* All Team Attendance Sagas */
function* handleAttendanceReportRequest() {
  const action = yield take(actions.attendanceReportRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(otherAttendanceService.attendanceReport, dataParams);
    if (res.isError) {
      yield put(actions.attendanceReportError(res));
    } else {
      yield put(actions.attendanceReportSuccess(res));
    }

  } catch (error) {
    yield put(actions.attendanceReportError());
  }
}

/* All Team Attendance Sagas */
function* handleGetDepartmentWiseAttendanceRequest() {
  const action = yield take(actions.getDepartmentWiseAttendanceRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(otherAttendanceService.getDepartmentWiseAttendance, dataParams);
    if (res.isError) {
      yield put(actions.getDepartmentWiseAttendanceError(res));
    } else {
      yield put(actions.getDepartmentWiseAttendanceSuccess(res));
    }

  } catch (error) {
    yield put(actions.getDepartmentWiseAttendanceError());
  }
}

/*  Get All Employee Attendance Sagas */
function* handleGetAllEmployeeAttendanceRequest() {
  const action = yield take(actions.getAllEmployeeAttendanceRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(otherAttendanceService.getAllEmployeeAttendance, dataParams);
    if (res.isError) {
      yield put(actions.getAllEmployeeAttendanceError(res));
    } else {
      yield put(actions.getAllEmployeeAttendanceSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllEmployeeAttendanceError());
  }
}

/* -----------Watchers------------- */
function* handleSelfAttendanceWatcher() {
  yield takeEvery(
    actions.selfAttendanceRequest,
    handleSelfAttendanceRequest,
  );
}

function* handleMyTeamAttendanceWatcher() {
  yield takeEvery(
    actions.myTeamAttendanceRequest,
    handleMyTeamAttendanceRequest,
  );
}

function* handleAllTeamAttendanceWatcher() {
  yield takeEvery(
    actions.allTeamAttendanceRequest,
    handleAllTeamAttendanceRequest,
  );
}

function* handleAttendanceReportWatcher() {
  yield takeEvery(
    actions.attendanceReportRequest,
    handleAttendanceReportRequest,
  );
}

function* handleGetDepartmentWiseAttendanceWatcher() {
  yield takeEvery(
    actions.getDepartmentWiseAttendanceRequest,
    handleGetDepartmentWiseAttendanceRequest,
  );
}

function* handleGetAllEmployeeAttendanceWatcher() {
  yield takeEvery(
    actions.getAllEmployeeAttendanceRequest,
    handleGetAllEmployeeAttendanceRequest,
  );
}

function* rootOtherAttendanceSaga() {
  yield all([
    handleSelfAttendanceRequest(),
    handleSelfAttendanceWatcher(),

    handleMyTeamAttendanceRequest(),
    handleMyTeamAttendanceWatcher(),

    handleAllTeamAttendanceRequest(),
    handleAllTeamAttendanceWatcher(),

    handleAttendanceReportRequest(),
    handleAttendanceReportWatcher(),
    
    handleGetDepartmentWiseAttendanceRequest(),
    handleGetDepartmentWiseAttendanceWatcher(),

    handleGetAllEmployeeAttendanceRequest(),
    handleGetAllEmployeeAttendanceWatcher(),

  ]);
}

export default rootOtherAttendanceSaga;
